import { cn } from "@/utils";
import { getScoreColor } from "@/utils/commonUtils";
import { Typography } from "../ui";
import { useTranslation } from "react-i18next";

const ScoreCell = ({ value }: { value: string | number }) => {
  const { t } = useTranslation();
  return (
    <>
      {value ? (
        <Typography
          variant="p"
          affects="medium"
          className={cn("text-center", getScoreColor(value?.toString()))}
        >
          {value}%
        </Typography>
      ) : (
        <Typography variant={"p"} className="text-center">
          {t("common:N_A")}
        </Typography>
      )}
    </>
  );
};
export default ScoreCell;
